module.exports = __webpack_public_path__ + "static/img/whitetitle3s.fa81600c.png";